<!-- 产品体系 -->
<template>
  <div class="frame">
    <img
      src="http://api.zyzxgc.cn/file/static/banner_product.jpg"
      class="banner"
    />
    <div :class="{ wrap: true, bg: activeTab == 1 }">
      <div class="breadcrumb w1200">
        <bread-crumb :breadcrumbs="routerHistory"></bread-crumb>
      </div>
      <sub-nav :subNavs="subNavs"></sub-nav>
      <div :class="{ out: activeTab == 0 }">
        <div class="container w1200">
          <div class="thirdNavs">
            <div
              :class="{ nav: true, active: activeTab == 0 }"
              @click="changeTab(0)"
            >
              产品类别
            </div>
            <div
              :class="{ nav: true, active: activeTab == 1 }"
              @click="changeTab(1)"
            >
              各阶段咨询产品
            </div>
          </div>
        </div>
        <div class="tab w1200" v-show="activeTab == 0">
          <sub-title title="产品类别" en="PRODUCT CATEGORY"></sub-title>
          <div class="box">
            <div class="list">
              <div
                :class="{ item: true, active: activeType == idx }"
                v-for="(item, idx) in types"
                :key="item.name"
                @mouseenter="changeType(idx)"
              >
                <div class="in">
                  <div class="num">
                    {{ idx > 8 ? idx + 1 : "0" + (idx + 1) }}
                  </div>
                  <div class="title">{{ item.name }}</div>
                </div>
                <img src="../../assets/type_more.png" class="more" />
              </div>
            </div>
            <div class="right">
              <img
                :src="types[activeType].post"
                :alt="types[activeType].name"
                class="post"
              />
              <div class="info">
                <div class="order">
                  {{ activeType > 8 ? activeType + 1 : "0" + (activeType + 1) }}
                </div>
                <div class="title">{{ types[activeType].name }}</div>
                <div class="line"></div>
                <div class="desc">{{ types[activeType].desc }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="tab tab2" v-show="activeTab == 1">
          <div class="w1200">
            <sub-title
              title="各阶段咨询产品"
              en="CONSULTING PRODUCTS AT ALL STAGES"
            ></sub-title>
          </div>
          <div class="box2">
            <div class="w1200 line-box">
              <div class="lines">
                <div
                  :class="{ line: true, active: activeLine == idx }"
                  v-for="(item, idx) in stages"
                  :key="item.title"
                  @mouseenter="changeLine(idx)"
                >
                  {{ item.title }}
                  <img src="../../assets/type_more.png" class="more" />
                </div>
              </div>
            </div>
            <div class="stage-desc">
              <div class="in w1200">
                <div
                  class="val"
                  v-for="item in stages[activeLine].desc"
                  :key="item"
                >
                  {{ item }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Store } from "@/store/index.js";
import { mapState } from "pinia";
import breadCrumb from "@/components/breadCrumb.vue";
import SubNav from "@/components/subNav.vue";
import SubTitle from "@/components/subTitle.vue";
export default {
  components: { breadCrumb, SubNav, SubTitle },
  data() {
    return {
      routerHistory: [], // 当前所在位置
      subNavs: [],
      activeTab: 0,
      types: [
        {
          name: "工程造价咨询",
          post: "http://api.zyzxgc.cn/file/static/productType1.png",
          desc: "公司接受委托，承担建设项目的全过程、动态的造价管理或专项造价咨询服务，包括可行性研究、投资估算、项目经济评价、工程概算、预算、工程量清单及招标控制价、工程竣工结算、工程招标标底、投标报价的编制和审核、对工程造价进行监控以及提供有关工程造价信息资料等业务。",
        },
        {
          name: "项目投资决策咨询",
          post: "http://api.zyzxgc.cn/file/static/productType2.png",
          desc: "接受委托，为客户提供其投资工程项目的建筑面积、平面布局、建筑造型、设备配置、招标方案、合约规划、工期推进安排、建筑方案比选等内容，为客户推荐经济合理的建筑策划方案的咨询服务。",
        },
        {
          name: "工程总承包咨询",
          post: "http://api.zyzxgc.cn/file/static/productType3.png",
          desc: "在工程建设中，接受建设单位或总承包单位委托，在可行性研究后或初步设计后，为客户提供以成本管理控制为主线的全过程咨询服务。",
        },
        {
          name: "施工总承包咨询",
          post: "http://api.zyzxgc.cn/file/static/productType4.png",
          desc: "在工程建设中，接受总承包单位委托，在施工图设计后，提供以成本管理控制为主线的全过程咨询服务。",
        },
        {
          name: "设计咨询",
          post: "http://api.zyzxgc.cn/file/static/productType5.png",
          desc: "根据建设工程的总体目标及要求，通过设计与造价融合模式，对项目的质量、投资、成本、进度、信息、合同等内容，在项目的前期阶段、设计阶段、施工阶段的设计文件成果进行监督、控制及管理，并对各阶段设计成果文件进行复核及审查，纠正偏差和错误，提出优化建议，出具咨询报告的咨询活动。",
        },
        {
          name: "招投标咨询",
          post: "http://api.zyzxgc.cn/file/static/productType6.png",
          desc: "1、招标咨询：接受招标企业委托，对工程的勘查、设计、施工、监理、造价以及工程建设有关的重要设备(进口机电设备除外)、材料采购招标的代理，组织开标、评标、定标工作的咨询服务。\n2、投标咨询：接受投标企业委托，根据招标文件要求，为投标人提供招标信息分析、投标策划、成本分析、投标文件编制、投标展示及相关配合等的咨询服务活动。",
        },
        {
          name: "工程信息数据咨询",
          post: "http://api.zyzxgc.cn/file/static/productType7.png",
          desc: "工程造价咨询企业为咨询行业或受客户委托，提供与建设工程相关的工程材料设备价格咨询、工程经济指标分析、工程技术指标分析、工程量指标分析的咨询服务活动。",
        },
        {
          name: "涉案造价咨询",
          post: "http://api.zyzxgc.cn/file/static/productType8.png",
          desc: "工程造价咨询公司接受涉案当事人委托，对诉讼或仲裁案件中的工程造价争议提供咨询意见的活动。",
        },
        {
          name: "工程项目管理",
          post: "http://api.zyzxgc.cn/file/static/productType9.png",
          desc: "工程造价咨询公司接受委托，运用系统的理论和方法，提供对建设工程项目自立项至竣工运营的计划、组织、指挥、协调和控制等全过程的项目管理服务",
        },
        {
          name: "BIM应用咨询",
          post: "http://api.zyzxgc.cn/file/static/productType10.png",
          desc: "工程造价咨询公司接受委托，运用 BIM 技术手段，对建设项目前期策划、设计、施工、竣工交付和运营维护等各个阶段提供咨询意见的过程。",
        },
      ],
      activeType: 0, // 类别
      stages: [
        {
          title: "项目建议书阶段",
          desc: [
            "1.项目可行性研究报告编制/评估; ",
            "2.项目建议书编制/评估;",
            "3.项目申请报告编制/评估;",
            "4.资金申请报告编制/评估;",
            "5.投融资咨询；",
            "6.项目投资机会研究。",
          ],
        },
        {
          title: "可行性研究阶段",
          desc: [
            "1.投资估算编制/审核;",
            "2.可行性经济评价; ",
            "3.项目建筑策划；",
            "4.工程总承包咨询；",
            "5.项目成本管理咨询；",
            "6.BIM应用咨询；",
            "7.工程信息指标咨询；",
            "8.工程项目管理咨询。",
          ],
        },
        {
          title: "设计阶段",
          desc: [
            "1.总体设计方案经济分析；",
            "2.专项设计方案经济分析；",
            "3.项目投资概算编制/评审;",
            "4.设计方案经济分析;",
            "5.工程信息指标咨询；",
            "6.项目成本管理咨询;",
            "7.限额设计造价咨询；",
            "8.工程总承包咨询;",
            "9.施工总承包咨询；",
            "10.合约规划咨询；",
            "11.项目投资风险控制咨询；",
            "12.工程合同咨询；",
            "13.BIM应用咨询；",
            "14.工程项目管理咨询。",
          ],
        },
        {
          title: "发承包阶段",
          desc: [
            "1.招标咨询；",
            "2.投标咨询；",
            "3.招标采购策划及合约规划；",
            "4.项目投资风险控制咨询；",
            "5.项目资金使用计划编制；",
            "6.工程量清单编制/审核；",
            "7.招标控制 价（最高投标限价、标底） 编制/审核；",
            "8.投标报价编制/审核；",
            "9.清标；",
            "10.项目成本管理咨询;",
            "11.工程信息指标咨询；",
            "12.项目投资风险控制咨询。",
            "13.BIM应用咨询；",
            "14.工程合同咨询；",
            "15.工程项目管理咨询。",
          ],
        },
        {
          title: "工程施工阶段",
          desc: [
            "1.施工阶段过程造价控制;",
            "2.生产要素价格咨询；",
            "3.项目投资风险控制咨询；",
            "4.BIM应用咨询；",
            "5.工程信息指标咨询；",
            "6.施工总承包咨询；",
            "7.项目成本管理咨询;",
            "8.工程合同咨询；",
            "9.涉案造价咨询；",
            "10.工程项目管理咨询。",
          ],
        },
        {
          title: "竣工验收阶段",
          desc: [
            "1.工程竣工结算编制/审核;",
            "2.项目投资绩效评价；",
            "3.项目后评估咨询；",
            "4.涉案造价咨询",
            "5.工程合同咨询；",
            "6.工程造价司法鉴定。",
          ],
        },
        {
          title: "运维阶段",
          desc: ["1．运维咨询。"],
        },
      ], // 阶段数据
      activeLine: 0,
    };
  },
  computed: {
    ...mapState(Store, ["navList"]),
  },
  created() {
    this.formatBreadCrumb();
    if (this.$route.query.tab !== undefined) {
      this.activeTab = this.$route.query.tab;
    }
  },
  mounted() {},
  methods: {
    // 格式化导航条和二级导航栏
    formatBreadCrumb() {
      let nav = this.navList.find(
        (ele) => ele.path != "/" && this.$route.path.includes(ele.path)
      );
      if (nav.subs && nav.subs.length != 0) {
        // 二级导航栏
        this.subNavs = nav.subs;
      }
      this.routerHistory = [{ path: "/", name: "首页" }, nav];
    },
    changeTab(idx) {
      this.$router.replace("/product/productType?tab=" + idx);
      this.activeTab = idx;
    },
    changeType(idx) {
      this.activeType = idx;
    },
    changeLine(idx) {
      this.activeLine = idx;
    },
  },
};
</script>

<style lang="scss" scoped>
.frame {
  .banner {
    width: 100%;
    display: block;
  }
  .wrap {
    background-size: cover;

    &::before,
    &::after {
      content: "";
      display: table;
    }
  }
  .wrap.bg {
    background-image: url("http://api.zyzxgc.cn/file/static/productStage_bg.png");
  }
  .breadcrumb {
    margin: 25px auto 20px;
  }
  .out {
    background-image: url("http://api.zyzxgc.cn/file/static/productType_bg.png");
    background-size: auto 100%;
    background-repeat: no-repeat;
  }
  .container {
    margin: 40px auto 30px;

    .thirdNavs {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 45px;

      .nav {
        font-size: 20px;
        color: #9a9a9a;
        line-height: 26px;
        cursor: pointer;

        &:hover {
          color: $theme;
          font-weight: bold;
        }

        & + .nav {
          margin-left: 35px;
        }
      }
      .active {
        color: $theme;
        font-weight: bold;
        position: relative;

        &::after {
          content: "";
          display: block;
          width: 37px;
          height: 3px;
          background-color: $theme;
          position: absolute;
          bottom: -8px;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
  }
  .tab2 {
    padding-bottom: 120px;
  }
  .tab {
    .box {
      display: flex;
      align-items: flex-start;
      margin-top: 70px;
      margin-bottom: 120px;

      .list {
        width: 450px;
        margin-right: 10px;

        .item {
          padding: 5px 0;
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          cursor: pointer;

          &:hover {
            .in {
              border-color: $theme;

              .num {
                -webkit-text-stroke: unset;
                color: $theme;
              }
              .title {
                color: $theme;
              }
            }
          }

          .in {
            width: 370px;
            display: flex;
            align-items: center;
            border-bottom: 1px solid transparent;

            .num {
              font-weight: bold;
              font-size: 50px;
              color: rgba(5, 58, 122, 0);
              text-stroke: 1px #5d5d5d;
              -webkit-text-stroke: 1px #5d5d5d;
            }
            .title {
              font-size: 20px;
              color: #5e5d5d;
              margin-left: 20px;
            }
          }
          .more {
            width: 30px;
            visibility: hidden;
          }
        }
        .active {
          .in {
            border-color: $theme;

            .num {
              -webkit-text-stroke: unset;
              color: $theme;
            }
            .title {
              color: $theme;
            }
          }
          .more {
            visibility: visible;
          }
        }
      }
      .right {
        flex-grow: 1;

        .post {
          width: 100%;
          height: 350px;
          object-fit: cover;
          display: block;
        }
        .info {
          background-color: $theme;
          padding: 20px;
          box-sizing: border-box;
          color: #fff;
          position: relative;

          .order {
            font-weight: bold;
            font-size: 70px;
            color: rgba(55, 14, 14, 0);
            text-stroke: 1px #ffffff;
            opacity: 0.2;
            -webkit-text-stroke: 1px #ffffff;
            position: absolute;
            right: 20px;
            top: 20px;
          }
          .title {
            font-size: 25px;
          }
          .line {
            width: 49px;
            height: 3px;
            background-color: #fff;
            margin: 20px 0;
          }
          .desc {
            text-indent: 2em;
            line-height: 36px;
            white-space: pre-wrap;
          }
        }
      }
    }
    .lines {
      height: 50px;
      margin-top: 100px;
      background-image: url("../../assets/across.png");
      background-size: contain;
      background-repeat: no-repeat;
      background-position-y: center;
      position: relative;

      .line {
        width: 178px;
        padding: 5px;
        box-sizing: border-box;
        border-radius: 10px;
        border: 2px solid #5e5d5d;
        color: #5e5d5d;
        text-align: center;
        cursor: pointer;
        position: absolute;

        &:hover {
          background-color: $theme;
          color: #fff;
          font-weight: bold;
          border-color: $theme;
        }
        &::before {
          content: "";
          display: block;
          width: 2px;
          height: 43px;
          background-color: #5e5d5d;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
        }
        &::after {
          content: "";
          display: block;
          width: 8px;
          height: 8px;
          background: #5e5d5d;
          border-radius: 50%;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
        }
        &:nth-child(1) {
          left: 0;
        }
        &:nth-child(2) {
          left: 156px;
        }
        &:nth-child(3) {
          left: 294px;
        }
        &:nth-child(4) {
          left: 450px;
        }
        &:nth-child(5) {
          left: 604px;
        }
        &:nth-child(6) {
          left: 760px;
        }
        &:nth-child(7) {
          left: 915px;
        }
        &:nth-child(2n) {
          bottom: -50px;

          &::before {
            bottom: 100%;
          }
          &::after {
            top: -46px;
          }
        }
        &:nth-child(2n + 1) {
          top: -50px;

          &::before {
            top: 100%;
          }
          &::after {
            bottom: -46px;
          }
        }

        .more {
          display: none;
        }
      }
      .active {
        background-color: $theme;
        color: #fff;
        font-weight: bold;
        border-color: $theme;

        &::before,
        &::after {
          background-color: $theme;
        }
      }
    }
    .stage-desc {
      background-color: $theme;
      min-height: 200px;
      padding: 25px 0;
      margin-top: 120px;
      display: flex;
      align-items: center;

      .in {
        display: flex;
        flex-wrap: wrap;

        .val {
          min-width: 25%;
          line-height: 40px;
          color: #ffffff;
          white-space: nowrap;
        }
      }
    }
  }
}

@media (max-width: 1600px) {
  .frame .tab .box .list .item {
    padding: 1px 0;

    .in {
      .num {
        font-size: 40px;
      }
      .title {
        font-size: 16px;
      }
    }
  }
  .frame .tab .box .right .post {
    height: 250px;
  }
}

@media (max-width: 750px) {
  .frame {
    .banner {
      height: auto;
    }
    .breadcrumb {
      display: none;
    }
    .container {
      margin: 20px 0;
      padding: 0 10px;
      box-sizing: border-box;

      .thirdNavs {
        padding: 0 10px;
        margin-bottom: 30px;

        .nav {
          font-size: 16px;

          & + .nav {
            margin-left: 10px;
          }
        }
      }
    }
    .tab {
      padding: 0 10px;
      box-sizing: border-box;

      .box {
        flex-direction: column;
        margin: 20px 0;

        .list {
          width: 100%;
          margin-right: 0;
          display: flex;
          overflow: auto;

          .item {
            white-space: nowrap;

            .in {
              width: 100%;

              .num {
                display: none;
              }
              .title {
                font-size: 16px;
                margin: 0 10px;
                padding: 10px 0;
              }
            }
            .more {
              display: none;
            }
          }
        }
        .right {
          .post {
            height: 280px;
          }
          .info {
            padding: 20px;

            .order {
              font-size: 80px;
              right: 20px;
              top: 20px;
            }
            .title {
              font-size: 20px;
            }
            .line {
              margin: 30px 0;
            }
            .desc {
              font-size: 16px;
            }
          }
        }
      }
      .box2 {
        display: flex;
        margin: 20px 0;

        .line-box {
          width: 120px;
          flex-shrink: 0;

          .lines {
            width: 100px;
            height: auto;
            margin-top: 0;
            padding: 20px 0;
            background-image: none;
            border-radius: 5px;
            background-color: #fff;
            box-shadow: 0px 0px 4px 0px rgba(4, 0, 0, 0.27);

            .line {
              position: relative;
              left: unset;
              right: unset;
              top: unset;
              bottom: unset;
              width: 100%;
              height: 44px;
              border-radius: 0;
              line-height: 34px;
              border: none;
              font-size: 12px;
              background-color: rgba(94, 93, 93, 0.08);
              color: #5e5d5d;

              &::before,
              &::after {
                display: none;
              }
              & + .line {
                margin-top: 20px;
              }

              .more {
                width: 13px;
                position: absolute;
                right: -17px;
                top: 50%;
                transform: translateY(-50%);
                display: none;
              }
            }
            .active {
              color: #fff;
              background-color: $theme;

              .more {
                display: block;
              }
            }
          }
        }
        .stage-desc {
          width: calc(100% - 120px);
          margin-top: 0;
          border-radius: 5px;
          font-size: 12px;
          padding: 10px;
          box-sizing: border-box;

          .in {
            align-items: center;
            flex-direction: column;

            .val {
              white-space: pre-wrap;
              text-align: center;
            }
          }
        }
      }
    }
  }
}
</style>
